import { render, staticRenderFns } from "./Vlad1.vue?vue&type=template&id=fa94a380&scoped=true"
import script from "./Vlad1.vue?vue&type=script&lang=js"
export * from "./Vlad1.vue?vue&type=script&lang=js"
import style0 from "./Vlad1.vue?vue&type=style&index=0&id=fa94a380&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa94a380",
  null
  
)

export default component.exports